// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"224d31f4","404":"f50b765b","787":"aadca95f"}[chunkId] + ".chunk.js";
};